export default __webpack_public_path__ + "static/media/verifyFailed-mobile.dd271f3c.png";